import { render, staticRenderFns } from "./block_page.vue?vue&type=template&id=70f4868a&scoped=true&"
import script from "./block_page.vue?vue&type=script&lang=js&"
export * from "./block_page.vue?vue&type=script&lang=js&"
import style0 from "./block_page.vue?vue&type=style&index=0&id=70f4868a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4868a",
  null
  
)

/* custom blocks */
import block0 from "./block_page.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports